import { render } from "./ReviewRatings.vue?vue&type=template&id=ede8d36c"
import script from "./ReviewRatings.vue?vue&type=script&lang=js"
export * from "./ReviewRatings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__